import ActBtn from 'components/buttons/ActBtn'
import FixedWarnings from 'components/FixedWarnings'
import * as PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Link, useHistory, useLocation } from 'react-router-dom'
import { klass, useBoolState } from 'utils'
import Btn from '../buttons/Btn'
import Head from './Head'
import Header from './Header'
import Menu from './Menu'

/**
 * @param title {string} Used in the header and tab title, if needed
 * @param pageTitle {string} If skipped, `title` will be used instead
 * @param back {boolean|string} Shows a Back button. If true, calls history.goBack(); if a string, will link to that.
 * @param corner {object|boolean} If given, will replace the search button; if false, doesn't render anything
 * @param forcedTitle {boolean} If true, will skip the use of the title template
 * @param children
 */
export default function Screen({ title, pageTitle = title, back = false, corner = null, forcedTitle = false, children }) {
	title = back? <><BackBtn to={back}/> {title}</> : title

	const showMenu = (useLocation().pathname != '/login')
	const menuOpen = useBoolState()

	return <>
		<Head/>
		<Head.PageTitle title={pageTitle} forcedTitle={forcedTitle}/>
		<Header toggleMenu={menuOpen.toggle} {...{ title, corner, showMenu }}/>
		{showMenu && <FixedWarnings/>}
		{showMenu && <Menu isOpen={menuOpen.is} toggle={menuOpen.flip}/>}
		{children}
	</>
}

Screen.propTypes = {
	back       : PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
	corner     : PropTypes.oneOfType([PropTypes.node, PropTypes.bool]),
	title      : PropTypes.node.isRequired,
	pageTitle  : PropTypes.string,
	forcedTitle: PropTypes.bool,
}

/** The scrollable content on the page */
Screen.Content = ({children, addPadding, className, ...props}) => (
	<main {...klass(className, { pFullPage: addPadding })} {...props}>{children}</main>
)

Screen.Content.propTypes = {
	addPadding: PropTypes.bool,
	className : PropTypes.string,
}

const BackBtn = ({ to = null }) => {
	const { t }   = useTranslation()
	const history = useHistory()
	const props = (typeof to == 'string')?
		{ to: `/${to}`, as: Link } :
		{ onClick: history.goBack }
	return <Btn icon="chevron-left" className="back d-print-none" title={t("Go Back")} {...props}/>
}

const SaveFooter = ({ disabled = false, action }) => {
	const { t } = useTranslation()
	return <footer>
		<Btn onClick={() => window.history.back()} swap icon="chevron-left" variant="outline-secondary">
			{t('Cancel', { context: 'go back' })}
		</Btn>

		<ActBtn variant="success" size="lg" {...{ disabled, action }} texts={[t('Save'), t('Saving'), t('Saved')]}/>
	</footer>
}
Screen.SaveFooter = SaveFooter //React hook rules bitches about Screen.SaveFooter created directly :|
Screen.SaveFooter.propTypes = {
	disabled: PropTypes.bool,
	action  : PropTypes.func.isRequired,
}
